// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sourse-boxs table {\n  border-top: 0 !important;\n  border-left: 0 !important;\n}\n.sourse-boxs table td, .sourse-boxs table th {\n  border-right: 0 !important;\n}\n", ""]);
// Exports
module.exports = exports;
